import { render, staticRenderFns } from "./ItemsCardComponent.vue?vue&type=template&id=3d1d2ba4&scoped=true"
import script from "./ItemsCardComponent.vue?vue&type=script&lang=js"
export * from "./ItemsCardComponent.vue?vue&type=script&lang=js"
import style0 from "./ItemsCardComponent.vue?vue&type=style&index=0&id=3d1d2ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1d2ba4",
  null
  
)

export default component.exports